import { Link } from 'react-router'
import type { BlogPost } from '#app/data/blog'

export function BlogCard({ post }: { post: BlogPost }) {
	return (
		<Link
			to={`/blog/${post.slug}`}
			className="group flex flex-col overflow-hidden rounded-2xl border border-[#AEAEAE] bg-white transition-shadow hover:shadow-md"
		>
			<div className="aspect-[16/9] overflow-hidden">
				<img
					src={post.listingImage ?? post.coverImage}
					alt={post.title}
					className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
				/>
			</div>

			<div className="flex flex-1 flex-col p-5">
				<span className="mb-3 inline-block self-start rounded-full bg-[#F8F9FA] px-3 py-1 text-xs font-medium text-[#32302F]">
					{post.category}
				</span>

				<h3 className="mb-2 text-[18px] font-semibold leading-snug text-[#32302F] transition-colors group-hover:text-black line-clamp-2">
					{post.title}
				</h3>

				<p className="mb-4 flex-1 text-sm leading-relaxed text-[#747474] line-clamp-2">
					{post.excerpt}
				</p>

				<div className="flex items-center gap-3 border-t border-[#AEAEAE] pt-4">
					<img
						src={post.author.avatar}
						alt={post.author.name}
						className="h-8 w-8 rounded-full object-cover"
					/>
					<div className="flex flex-col">
						<span className="text-xs font-medium text-[#32302F]">
							{post.author.name}
						</span>
						<span className="text-xs text-[#747474]">
							{new Date(post.publishedAt).toLocaleDateString('en-CA', {
								year: 'numeric',
								month: 'short',
								day: 'numeric',
							})}{' '}
							· {post.readTime} min read
						</span>
					</div>
				</div>
			</div>
		</Link>
	)
}
